<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <a
    class="link"
    @click.prevent="
      this.fetchContainerDetails();
      open = true;
    "
    ><i class="fa-solid fa-eye"></i><span class="space-icon"></span>
    Ver detalles
  </a>
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      class="fixed z-10 inset-0 overflow-y-auto"
      @close="open = false"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full sm:p-6"
          >
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
                @click="open = false"
              >
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="sm:flex sm:items-start" v-if="container">
              <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
                <DialogTitle
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  {{ container.container_code }}
                </DialogTitle>

                <div class="py-5">
                  <div class="grid grid-cols-1 md:grid-cols-2">
                    <div>
                      <div
                        class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-8"
                      >
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Exportadora
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            {{ container.agro_exporter.name }}
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Processo de exportación
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            {{ container.agro_exporter_process.name }}
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Planta de empaque
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            {{ container.packing_house.name }}
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Proceso de empaque
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            {{ container.packing_house_process.name }}
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Hora de inicio de carga
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            06 Ene 2022 02:44 AM
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Hora de fin de carga
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            06 Ene 2022 02:44 AM
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Nave
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            MAERSK BUTON 148N / POLAR PERU 147N
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Operador
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            AXIS GLOBAL LOGISTICS SAC
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Temperatura
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">8 °C</dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Hora de encendido
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            06 Ene 2022 02:44 PM
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Aduana
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">La aduna</dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Línea
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            Precinto líneas
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            Operador
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            El operador
                          </dd>
                        </div>
                        <div class="sm:col-span-1">
                          <dt class="text-base font-medium text-gray-500">
                            SENASA
                          </dt>
                          <dd class="mt-1 text-base text-gray-900">
                            Precinto SENASA
                          </dd>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="text-lg leading-6 pt-8 md:pt-0">Pallets</div>
                      <dd class="mt-1 text-base text-gray-900">
                        <div class="inline-block min-w-full py-2 align-middle">
                          <div
                            class="overflow-hidden shadow md:rounded-lg"
                          >
                            <div class="container my-auto mx-auto">
                              <div class="flex flex-wrap">
                                <div
                                  class="my-1 px-1 w-1/2 lg:my-4 lg:px-4 lg:w-1/2"
                                  v-for="package_group in container.package_groups"
                                  :key="package_group.id"
                                >
                                  <article
                                    class="overflow-hidden rounded-lg shadow-lg"
                                  >
                                    <header
                                      class="flex items-center justify-between leading-tight p-2 md:p-4"
                                    >
                                      <h1 class="text-lg">
                                        <a
                                          class="no-underline hover:underline text-black"
                                          href="#"
                                        >
                                          {{ package_group.pg_code }}
                                        </a>
                                      </h1>
                                      <p class="text-grey-darker text-sm">
                                        {{
                                          package_group.total_harvested_amount
                                        }}
                                        Kg
                                      </p>
                                    </header>
                                  </article>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </dd>
                      <div>
                        <img src="https://agrotec.pe/images/container.jpg" alt="Contenedor" class="max-h-250 rounded-lg">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                @click="open = false"
              >
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import BasicProductionRequester from "@/views/open_queries/requesters/customer/basic_production.js";

import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "OQProducerBasicProductionDetails",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  props: ["container_id"],
  setup() {
    const open = ref(false);

    return {
      open,
    };
  },
  data() {
    return {
      data_loaded: false,
      container: null,
      harvested_exp_packages: [],
    };
  },
  methods: {
    fetchContainerDetails: async function () {
      if (!this.data_loaded) {
        let response = await BasicProductionRequester.getProductionDetails(
          this.container_id
        );
        this.container = response.data;
        this.data_loaded = true;
      }
    },
  },
};
</script>
